import { render } from "./IconChevronDownBlack.vue?vue&type=template&id=07c635e3&ts=true"
import script from "./IconChevronDownBlack.vue?vue&type=script&lang=ts"
export * from "./IconChevronDownBlack.vue?vue&type=script&lang=ts"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__